<template>
    <div>
    <div>
        <label style="width: 100%">
            <gmap-autocomplete
                    @place_changed="setPlace" :options="{fields: ['geometry', 'formatted_address', 'address_components']}" style="width: 100%">
            </gmap-autocomplete>
            <!--<button @click="addMarker">Search</button>-->
        </label>
        <br/>

    </div>
    <gmap-map
            :center="center"
            :zoom="12"
            style="width:100%;  height: 400px;"
    >
        <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
        ></gmap-marker>
    </gmap-map>
    </div>
</template>

<script>
    export default {
        name: "GoogleMap",
        data() {
            return {
                // default to montreal to keep it simple
                // change this to whatever makes sense
               // center: { lat: 45.508, lng: -73.587 },
                center: { lat: 22.285, lng: 114.211 },
                markers: [],
                places: [],
                currentPlace: null
            };
        },

        mounted() {
            this.geolocate();
        },

        methods: {
            setPlace(place) {
                this.currentPlace = place;
                this.addMarker();
            },
            addMarker() {
                if (this.currentPlace) {
                    const marker = {

                        lat: this.currentPlace.geometry.location.lat(),
                        lng: this.currentPlace.geometry.location.lng()
                    };
                    this.markers.push({ position: marker });
                    this.places.push(this.currentPlace);
                    this.center = marker;
                    this.currentPlace = null;
                }
            },
            geolocate: function() {
                navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                });
            }
        }
    };
</script>

<style scoped>

</style>